export class UserGroup {
  UserGrp;
  GrpDesc;
  ChiDesc;
  ModifyBy;
  constructor() {
    this.UserGrp = "";
    this.GrpDesc = "";
    this.ChiDesc = "";
    this.ModifyBy = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/UserGroup.js